export const statusFilters = [
  { key: 'orgPage-status', label: 'Prospect', value: 'Prospect', color: 'rgb(93, 79, 251)' },
  { key: 'orgPage-status', label: 'Onboarding', value: 'Onboarding', color: 'rgb(92, 179, 253)' },
  // { key: 'orgPage-status', label: 'In-Progress', value: 'In Progress', color: 'rgb(110, 156, 222)' },
  { key: 'orgPage-status', label: 'Active', value: 'Active', color: 'rgb(152, 214, 129)' },
  // { key: 'orgPage-status', label: 'Active (SEO)', value: 'Active (SEO)', color: 'rgb(152, 98, 161)' },
  // { key: 'orgPage-status', label: 'Active (Creative)', value: 'Active (Creative)', color: 'rgb(147, 111, 218)' },
  // { key: 'orgPage-status', label: 'Active (Website)', value: 'Active (Website)', color: 'rgb(102, 69, 169)' },
  // { key: 'orgPage-status', label: 'Active (Past Due', value: 'Active (Past Due)', color: 'rgb(255, 131, 88)' },
  // { key: 'orgPage-status', label: 'Active (LTP)', value: 'Active (LTP)', color: 'rgb(51, 158, 205)' },
  { key: 'orgPage-status', label: '30 day notice', value: '30 day notice', color: 'rgb(235, 77, 77)' },
  { key: 'orgPage-status', label: 'Canceled', value: 'Cancelled', color: 'rgb(0,0,0)' },
  { key: 'orgPage-status', label: 'Inactive / Paused', value: 'Inactive / Paused', color: 'rgb(255, 145, 145)' },
  { key: 'orgPage-status', label: 'Pending', value: 'Pending', color: 'rgb(187, 124, 239)' },
  { key: 'orgPage-status', label: 'Parent', value: 'Parent', color: 'rgba(67, 85, 241, 1)' },
]
export const organizationTypeOptions = [
  {
    key: 'orgPage-type',
    label: 'Property Management Company',
    value: 'Property Management Company',
    color: 'rgb(93, 79, 251)',
  },
  { key: 'orgPage-type', label: 'Ownership Group', value: 'Ownership Group', color: 'rgb(92, 179, 253)' },
  { key: 'orgPage-type', label: 'Housing Property', value: 'Housing Property', color: 'rgb(152, 214, 129)' },
  { key: 'orgPage-type', label: 'Parent Client', value: 'Parent Client', color: 'rgb(93, 79, 251)' },
  { key: 'orgPage-type', label: 'Agency Whitelabel', value: 'Agency Whitelabel', color: 'rgb(92, 179, 253)' },
  {
    key: 'orgPage-type',
    label: 'Organization',
    value: 'Organization',
    color: 'rgb(242, 140, 40)',
  },
]
